import { useRef, useState } from "react";
import { Upload, FileText, X } from "lucide-react";
import { api, API, errMsg } from "@/lib/api";
import { toast } from "sonner";

export const FileField = ({ field, value, onChange }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/files", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(`${data.filename}|${data.file_id}`);
      toast.success("File uploaded");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  const [name, id] = (value || "").split("|");

  if (value && id) {
    return (
      <div className="mt-1.5 flex items-center gap-2 rounded-md border border-[#E5E7EB] bg-[#F3F4F6] px-3 py-2">
        <FileText className="h-4 w-4 text-[#002FA7]" />
        <a href={`${API}/files/${id}`} target="_blank" rel="noreferrer"
          className="text-sm text-[#002FA7] hover:underline truncate flex-1" data-testid={`file-link-${field.name}`}>
          {name}
        </a>
        <button type="button" onClick={() => onChange("")} data-testid={`file-remove-${field.name}`}>
          <X className="h-4 w-4 text-[#6B7280]" />
        </button>
      </div>
    );
  }

  return (
    <div className="mt-1.5">
      <input ref={ref} type="file" className="hidden" data-testid={`file-input-${field.name}`}
        onChange={(e) => upload(e.target.files?.[0])} />
      <button type="button" onClick={() => ref.current?.click()} disabled={busy}
        data-testid={`file-upload-${field.name}`}
        className="w-full flex items-center justify-center gap-2 rounded-md border border-dashed border-[#E5E7EB] bg-[#F3F4F6] px-3 py-3 text-sm text-[#6B7280] hover:border-[#002FA7] hover:text-[#002FA7] transition-colors">
        <Upload className="h-4 w-4" /> {busy ? "Uploading…" : "Click to upload (max 10MB)"}
      </button>
    </div>
  );
};
